import React, { useState } from 'react';
import { FileText, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

const Step1JobDescription = ({ wizardData, updateWizardData, nextStep }) => {
  const [jd, setJd] = useState(wizardData.jobDescription || '');

  const handleNext = () => {
    if (!jd.trim()) {
      return;
    }
    updateWizardData({ jobDescription: jd });
    nextStep();
  };

  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-3 sm:mb-4">
          Paste Job Description
        </h2>
        <p className="text-base sm:text-lg text-muted-foreground">
          Copy and paste the full job description you're applying for
        </p>
      </div>

      <div className="space-y-4">
        <Label htmlFor="job-description" className="text-base font-semibold">
          Job Description
        </Label>
        <Textarea
          id="job-description"
          data-testid="job-description-input"
          placeholder="Paste the job description here...&#10;&#10;Include job title, responsibilities, requirements, skills, and any other relevant details."
          value={jd}
          onChange={(e) => setJd(e.target.value)}
          className="min-h-[300px] sm:min-h-[400px] text-sm sm:text-base"
        />
      </div>

      <div className="flex justify-end">
        <Button
          data-testid="next-step-btn"
          size="lg"
          onClick={handleNext}
          disabled={!jd.trim()}
          className="h-12 px-6 sm:px-8 font-semibold transition-all active:scale-95 w-full sm:w-auto"
        >
          Continue
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button>
      </div>
    </div>
  );
};

export default Step1JobDescription;
